import { render } from "./slidePage.vue?vue&type=template&id=77331e9c&scoped=true"
import script from "./slidePage.vue?vue&type=script&lang=js"
export * from "./slidePage.vue?vue&type=script&lang=js"

import "./slidePage.vue?vue&type=style&index=0&id=77331e9c&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77331e9c"]])

export default __exports__